import { ChaseSpinner } from '@components';
import { Layout } from '@components/Layouts';
import { EmptyContent } from '@components/Ui';

export default function LoaderPage() {
  return (
    <Layout showFeatures={false} className="flex justify-center">
      <EmptyContent>
        <ChaseSpinner color="primary" className="h-10 w-10" />
      </EmptyContent>
    </Layout>
  );
}
